import {
  formatDate,
  paymentStatusBadgeClass,
  fulfillmentStatusBadgeClass,
  formatAmountForDisplay,
} from "./examUtils";
import { htmlToText } from "../../../utils/toDisplayString";

/**
 * The "Recent Purchases" panel from the exam-dashboard payload.
 *
 * Full width with a scrollable body (the header stays put) — the admin dashboard
 * page pins it to the very bottom, the Exam Purchases page renders it with the
 * rest of the recent-activity panels.
 */
const RecentPurchasesPanel = ({ purchases }) => {
  if (!purchases || purchases.length === 0) return null;

  return (
    <div className="flex max-h-[500px] min-h-[120px] min-w-0 flex-1 basis-[320px] flex-col rounded-lg border border-slate-200 bg-white p-3 shadow-sm">
      <h4 className="mb-2 shrink-0 text-[11px] font-bold uppercase tracking-wide text-emerald-600">
        Recent Purchases
      </h4>
      <div className="min-h-0 flex-1 overflow-y-auto pr-1">
        {purchases.map((p) => (
          <div
            key={p.id}
            className="flex items-center justify-between gap-2 border-b border-slate-100 py-2 last:border-0"
          >
            <div className="min-w-0">
              <p className="m-0 truncate text-sm font-semibold text-slate-800">
                {htmlToText(p.customerName || p.customerEmail || p.reference) || "—"}
              </p>
              <p className="m-0 truncate text-xs text-slate-500">
                {htmlToText(p.customerEmail)} &bull; ₦{formatAmountForDisplay(p.amount)}
              </p>
              <p className="m-0 text-[11px] text-slate-400">{formatDate(p.createdAt)}</p>
            </div>
            <div className="flex flex-col items-end gap-1">
              <span className={paymentStatusBadgeClass(p.paymentStatus)}>
                {p.paymentStatus}
              </span>
              <span className={fulfillmentStatusBadgeClass(p.fulfillmentStatus)}>
                {p.fulfillmentStatus}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentPurchasesPanel;
